import { Controller } from "@hotwired/stimulus";
import { patch } from "@rails/request.js";

// Connects to data-controller="storage-area--manage"
export default class extends Controller {
  static targets = ["form", "tierType"];

  static values = {
    url: String,
  };

  cardTargetConnected(element) {
    const $targets = $(element);

    this.makeDraggable($targets);
  }

  makeDraggable($targets) {
    const $draggableCards = $targets;
    const $droppableCards = $draggableCards.not(".tier-5");

    $draggableCards.draggable({
      cursor: "crosshair",
      handle: ".fa-grip-vertical",
      revert: "invalid",
    });

    $droppableCards.droppable({
      accept: ".tier-card",
      classes: {
        "ui-droppable-active": "border-secondary",
        "ui-droppable-hover": "border-success",
      },
      drop: (event, ui) => {
        $.LoadingOverlay("show");

        const sourceId = ui.draggable.data("storage-area-id");
        const targetId = event.target.dataset.storageAreaId;

        patch(this.urlValue, {
          body: {
            source_id: sourceId,
            target_id: targetId,
          },
          responseKind: "turbo-stream",
        }).then(
          () => {
            $.LoadingOverlay("hide");
          },
          () => {
            alert("Unable to move storage area, please try again.");
            window.location.reload();
          }
        );
      },
    });
  }
}
